import { Button, Flex, Spacer } from "@chakra-ui/react";
import React from "react";
import { AdminFormButtons } from "src/components/Layout/AdminFormButtons";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { JsonEditor } from "src/scenes/admin/components/JsonEditor";
import { useFormTemplateContext } from "../../formTemplateContext";
import { useEditFormTemplateContext } from "./context";
import client from "./FormTemplateClient";

type Props = {
  onBack: () => void;
};
export const ImportFromJSON: React.FC<Props> = ({ onBack }) => {
  const [json, setJson] = React.useState("");
  const { formTemplate } = useFormTemplateContext();
  const importJSON = client.useImportFromJSON();

  const avelaToast = useAvelaToast();

  const [isImporting, setImporting] = React.useState(false);
  const { dispatch } = useEditFormTemplateContext();

  const [schema, setSchema] = React.useState<object>({});
  React.useEffect(() => {
    (async () => {
      try {
        // Import the pre-generated form template schema
        const formTemplateSchema = await import(
          "src/generated/form-template-openapi.json"
        );
        setSchema(formTemplateSchema.default || formTemplateSchema);
      } catch (error) {
        console.error(error);
        setSchema({});
      }
    })();
  }, []);
  return (
    <Flex direction="column" grow="1" height="100%">
      <JsonEditor
        schema={schema}
        text={json}
        onChange={setJson}
        filename="formTemplate.json"
        editorHeight="fillParent"
      />
      <Spacer />
      <AdminFormButtons insideTabPanel>
        <Button
          variant="outline"
          colorScheme="gray"
          onClick={() => {
            onBack();
          }}
        >
          Back
        </Button>
        <Spacer />
        <Button
          isLoading={isImporting}
          onClick={async () => {
            try {
              setImporting(true);
              const schema = JSON.parse(json);
              const response = await importJSON(formTemplate.id, schema);

              if (!response.data) {
                throw new Error("No data received");
              }

              if (response.data.data.schema.schemaVersion !== "2.0.0") {
                throw new Error("Invalid schema version");
              }

              dispatch({
                type: "SetFormTemplate",
                formTemplate: response.data.data.schema,
              });
              dispatch({
                type: "SetImportErrors",
                errors: response.data.data.errors,
              });

              avelaToast({
                title: "Imported from JSON",
                description: `Content imported from JSON`,
              });

              onBack();
            } catch (error) {
              console.error(error);
              avelaToast.genericError();
            } finally {
              setImporting(false);
            }
          }}
        >
          Import
        </Button>
      </AdminFormButtons>
    </Flex>
  );
};
